import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

const issueEnglishIqHandoffV1DataSchema = z.object({
  expiresAt: z.number().int().positive(),
  handoffToken: z.string().min(1),
});

export type IIssueEnglishIqHandoffV1Data = z.infer<typeof issueEnglishIqHandoffV1DataSchema>;

export const issueEnglishIqHandoffV1ResponseSchema: z.ZodSchema<
  IAPI<IIssueEnglishIqHandoffV1Data>
> = createApiResponseSchema(issueEnglishIqHandoffV1DataSchema) as z.ZodSchema<
  IAPI<IIssueEnglishIqHandoffV1Data>
>;

export type IIssueEnglishIqHandoffV1Response = IAPI<IIssueEnglishIqHandoffV1Data>;
